module.exports = __webpack_public_path__ + "img/kwh.084495bd.svg";